import Component from "./PuppyPoolPartySnapshot";
export default Component;
